<template>
  <div class="row q-col-gutter-x-md">
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Vehicle Cap Cost*</label>
      <q-field outlined :value="cost" :error="!isValid">
        <template #control>
          <currency-input @keypress.enter="validController" v-model="cost" class="q-field__input text-right abc-d" />
        </template>
        <template v-slot:error>Required Field.</template>
      </q-field>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Lease Period(Month)*</label>
      <q-input
        v-model="period"
        type="number"
        @keypress.enter="validController"
        input-class="text-right abc-d"
        outlined
        :rules="[
          val => (val !== null && val !== '') || 'Required Field.',
          val => (val <= 100 && val >= 1) || 'Period range 1-100 months'
        ]"
      ></q-input>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Monthly Depreciation % Amount*</label>
      <q-input
        @keypress.enter="validController"
        outlined
        suffix="%"
        v-model.number="monthDepAmountPer"
        :rules="[
          val => (val !== null && val !== '') || 'Required Field.',
          val => (val <= 100 && val > 0) || 'Percentage range 0-100'
        ]"
        input-class="abc-d text-right"
      />
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Monthly Lease Interest % Amount*</label>
      <q-input
        @keypress.enter="validController"
        outlined
        suffix="%"
        v-model.number="leaseAmountPer"
        :rules="[
          val => (val !== null && val !== '') || 'Required Field.',
          val => (val <= 100 && val > 0) || 'Percentage range 0-100'
        ]"
        input-class="abc-d text-right"
      />
    </div>
    <div>
      <q-btn :loading="loading" color="primary" :disable="disableController || loading" @click="calculate"
        >Calculate</q-btn
      >
    </div>
  </div>
</template>
<script>
import axios from '../axios'
import round from 'lodash.round'
export default {
  methods: {
    validController() {
      !this.disableController ? this.calculate() : ''
    },
    async calculate() {
      this.show = false
      this.loading = true
      this.$store.commit('calculator/RESET_VALS', '')

      const body = {
        type: 'lease',
        amount: this.cost,
        period: parseInt(this.period),
        monthly_depreciation_rate: this.monthDepAmountPer,
        monthly_interest_rate: this.leaseAmountPer
      }
      const { data } = await axios.post('calculator/finance', body)
      const { payoff, monthly_interest_payment, annual_interest_rate, plan } = data.data
      this.show = true
      this.loading = false
      this.financeArr = plan
      this.payment = monthly_interest_payment
      this.residualValue = payoff
      this.annualLeaseNotPer = annual_interest_rate * 100
    }
  },
  data() {
    return {
      loading: false,
      cost: 10000,
      period: 12,
      monthDepAmountPer: 1,
      leaseAmountPer: 0.5
    }
  },
  computed: {
    annualLeaseNotPer: {
      get() {
        return this.$store.state.calculator.annualLeaseNotPer
      },
      set(val) {
        this.$store.commit('calculator/SET_ANNUAL_NOT_PER', val)
      }
    },
    financeArr: {
      get() {
        return this.$store.state.calculator.financeArr
      },
      set(val) {
        this.$store.commit('calculator/SET_PAYMENT_DETAILS', val)
      }
    },
    show: {
      get() {
        return this.$store.state.calculator.show
      },
      set(val) {
        this.$store.commit('calculator/SET_SHOW', val)
      }
    },
    payment: {
      get() {
        return this.$store.state.calculator.payment
      },
      set(val) {
        this.$store.commit('calculator/SET_PAYMENT', val)
      }
    },
    residualValue: {
      get() {
        return this.$store.state.calculator.residualValue
      },
      set(val) {
        this.$store.commit('calculator/SET_RESIDUAL_VALUE', val)
      }
    },
    disableController() {
      if (
        this.cost &&
        this.period &&
        this.period <= 100 &&
        this.period > 0 &&
        this.monthDepAmountPer > 0 &&
        this.monthDepAmountPer <= 100 &&
        this.leaseAmountPer > 0 &&
        this.leaseAmountPer <= 100
      )
        return false
      else return true
    },
    isValidLeaseAmout() {
      return this.leaseAmountPer
    },
    isValidDepAmount() {
      return this.monthDepAmountPer
    },
    isValid() {
      return this.cost
    }
  }
}
</script>

<style lang="scss">
.abc-d {
  color: #000 !important;
}
.form-element-calculator {
  margin: 10px 0px;
}
.calculate-label {
  font-size: 15px;
  color: #027be3;
  font-weight: bold;
}
</style>
